'use strict';

exports.hypotenuse = function hypotenuse(a, b) {
    var r;
    if (Math.abs(a) > Math.abs(b)) {
        r = b / a;
        return Math.abs(a) * Math.sqrt(1 + r * r);
    }
    if (b !== 0) {
        r = a / b;
        return Math.abs(b) * Math.sqrt(1 + r * r);
    }
    return 0;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-pls/~/ml-matrix/src/dc/util.js
 ** module id = 121
 ** module chunks = 0
 **/